import type { RemainingTime } from '@/utils/date/difference-between-times';
import { getDifferenceBetweenTimes } from '@/utils/date/difference-between-times';
import { getText } from '../text/text';

const isInvalidTime = (time?: number | '') => {
    return time === '' || time === null || time === undefined;
};

export const getTimeLeftText = (timeLeft: RemainingTime | null, shortFormatText = false): string | null => {
    if (!timeLeft) {
        return '';
    }

    let timeLeftText = '';

    if (timeLeft?.days > 0) {
        timeLeftText += `${timeLeft.days} ${getText({
            text: `components.dateAndTimeUnits.days${shortFormatText ? '.short' : ''}`,
            n: timeLeft.days
        })} `;
    }

    if (timeLeft?.hours > 0) {
        timeLeftText += `${timeLeft.hours} ${getText({
            text: `components.dateAndTimeUnits.hours${shortFormatText ? '.short' : ''}`,
            n: timeLeft.hours
        })} `;
    }

    if (timeLeft?.minutes > 0) {
        timeLeftText += `${timeLeft.minutes} ${getText({
            text: `components.dateAndTimeUnits.minutes${shortFormatText ? '.short' : ''}`,
            n: timeLeft.minutes
        })} `;
    }

    return `${timeLeftText} ${getText({ text: 'common.left' })}`;
};

export const getTimeLeft12hFormat = (hiddenTime?: number | '') => {
    if (isInvalidTime(hiddenTime)) {
        return '';
    }

    const date = new Date(hiddenTime);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const amPm = hours >= 12 ? 'pm' : 'am';

    if (hours > 12) {
        hours -= 12;
    }

    if (hours === 0) {
        hours = 12;
    }

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}${amPm}`;
};

export const calculateTimeLeft = ({
    isJustWonState,
    currentTime,
    hiddenTime,
    targetTime
}: {
    isJustWonState: boolean;
    currentTime?: number | '';
    hiddenTime?: number | '';
    targetTime?: number | '';
}): RemainingTime | null => {
    if (isInvalidTime(currentTime) || isInvalidTime(hiddenTime) || isInvalidTime(targetTime)) {
        return null;
    }

    if (isJustWonState) {
        return getDifferenceBetweenTimes(hiddenTime, currentTime);
    }
    return getDifferenceBetweenTimes(targetTime, currentTime);
};

export const getTime = (time: { current?: string; target?: string; hidden?: string }) => {
    const currentTime = time?.current && Date.parse(time?.current?.split(' ')?.join('T'));
    const targetTime = time?.target && Date.parse(time?.target?.split(' ')?.join('T'));
    const hiddenTime = time?.hidden && Date.parse(time?.hidden?.split(' ')?.join('T'));

    return { currentTime, targetTime, hiddenTime };
};
